module.exports = __webpack_public_path__ + "static/en-logo100-web-832b0923b21e24be5d30e9b07d512804.svg";